// import { client } from '../initAWS.js'
import { defer } from 'lodash'
import { configInitialValuesBase, configKeysForCloud } from '../../helper/configs'
// import 'aws-appsync'
import { globalOnDemandVars } from '../../helper/context'
import { JSONParserForMosaicValue } from '../../helper/functions'
import Firestore from '../initFirebase.js'
import { updateConfigToCloud } from './updateData'

// export const configInitialValues = cloneWith(configInitialValuesBase, (config) => ((config && typeof config === 'object') ? JSON.stringify(config) : config))
let stringKeys = []
export const configInitialValues = {}
Object.keys(configInitialValuesBase).forEach((key) => {
  const value = configInitialValuesBase[key]

  if (typeof value === 'string' || value === null) {
    stringKeys.push(key)
  }

  if (value && typeof value === 'object') {
    configInitialValues[key] = JSON.stringify(value)
  } else {
    configInitialValues[key] = value
  }
})

export async function initConfig () {
  globalOnDemandVars.set_configReady(false)
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('init config 시작')
  }
  const configDoc = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('Config').doc('config')
  return configDoc.get().then((doc) => { // result.data.listTodos 형식이 반환임
    // const Config = result.data.getConfig
    let Config
    Config = doc.data()
    let configFromCloud
    if (!Config) {
      (async () => {
        if (process.env.NODE_ENV !== 'production') {
          console.tron.log('config create 시작')
        }
        // clearTimeOut = setTimeout(() => {
        //   location.reload()
        // }, 1000 * 5)
        await configDoc.set({
          ...configInitialValues
        })
        // const result = await configDoc.get()
        // if (process.env.NODE_ENV !== 'production') {
        //   console.tron.display({
        //     name: 'config create result',
        //     value: {
        //       result
        //     }
        //   // , important: true
        //   })
        // updateLocalConfigFromCloud(configFromCloud)
        // globalOnDemandVars.set_configReady(true)
      })()
      // }
      configFromCloud = configInitialValues
    } else {
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'appsync / create 안된 원래있던 config ',
          value: { Config }
        // , important: true
        })
      }
      configFromCloud = Config

      configKeysForCloud.forEach((configKey) => {
        if (typeof configFromCloud[configKey] === 'undefined') {
          configFromCloud[configKey] = configInitialValues[configKey]
          defer(() => {
            updateConfigToCloud([configKey])
          })
        }
      })

      // updateLocalConfigFromCloud(configFromCloud)
      // globalOnDemandVars.set_configReady(true)
    }

    if (globalOnDemandVars.isSharing()) {
      configFromCloud = {
        ...configFromCloud,
        sidebarCurrent: 'sharing',
        insertConfig: JSON.stringify({
          dockVisible: false,
          dockHeight: 0.4,
          sidebarVisible: true
        }),
        fullScreenBoolean: false,
        todoListItems: JSON.stringify([]),
        helpSectionOpen: false,
        helpSectionId: 'tour',
        Window2InitialValue: null
      }
    }

    updateLocalConfigFromCloud(configFromCloud)
    globalOnDemandVars.set_configReady(true)
  })
}

function updateLocalConfigFromCloud (configFromCloud) {
  Object.keys(configFromCloud).forEach((key) => {
    // if (key === 'id' || key === '__typename') {
    //   return
    // }
    if (configKeysForCloud.some((cloudKey) => (cloudKey === key))) {
      const value = configFromCloud[key]
      let parsedValue = value
      // 애초에 받아야되는 값 자체가 JSON인 config 값 주의...!
      // if (typeof value === 'string' && key !== 'Window2InitialValue' && key !== 'wrongNodeDescendants' && key !== 'topRootName' && key !== 'helpSectionId' && key !== 'email') {
      if (typeof value === 'string' && !(stringKeys.some((stringKey) => (stringKey === key)))) {
      // if (typeof value === 'string') {
        parsedValue = JSON.parse(value)
      } else if (key === 'Window2InitialValue') {
        parsedValue = JSONParserForMosaicValue(value)
      }
      globalOnDemandVars[`set_${key}`](parsedValue)

      if (key === 'Window2InitialValue') {
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'Window2InitialValue init',
            value: {
              key,
              value,
              parsedValue: parsedValue,
              setValue: globalOnDemandVars[key]()
            }
          // , important: true
          })
        }
      }
      if (key === 'Window2InitialValue') {
        globalOnDemandVars.set_mosaicValue(parsedValue)
        globalOnDemandVars.set_Window2InitialValueForGlobalId(parsedValue)
      }
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'appsync config forEach',
          value: {
            key,
            value,
            parsedValue: parsedValue,
            setValue: globalOnDemandVars[key]()
          }
        // , important: true
        })
      }
    }
  })
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('appsync/ configReady true 됨')
  }
}

// -----------------------------------------------------------------------------------------------------------

export async function initChatMemo () {
  globalOnDemandVars.set_chatMemoReady(false)
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('appsync / initChatMemo 1')
  }
  const Doc = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('Config').doc('chatMemo')
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('appsync / initChatMemo 1.5')
  }
  // TODO 로그인 안된 상태에서 연 후에 로그인하면 여기서 Cross origin으로 실패함. 왜인진 모르겠고 고치지도 못하겠음... 그래도 localhost에서 돌릴때만 실패한다는 얘기가 있으니까 일단 걍 두고보자
  const doc = await Doc.get()
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('appsync / initChatMemo 1.75')
  }
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'appsync / initChatMemo 2',
      value: {
        data: doc.data()
      // ChatMemo
      }
    // , important: true
    })
  }
  const ChatMemo = doc.data()
  let ChatMemoFromCloud
  if (!ChatMemo) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('appsync / initChatMemo / ChatMemo: null')
    }
    const data = {
      // id: globalOnDemandVars.userData().username,
      value: ''
    }
    await Doc.set(data)
    // const creationResult = await Doc.get()
    // if (process.env.NODE_ENV !== 'production') {
    //   console.tron.display({
    //     name: 'appsync / create 후의 ChatMemo ',
    //     value: {
    //       creationResult,
    //       data: creationResult.data()
    //     // ChatMemo: result.data.getChatMemo
    //     }
    //   // , important: true
    //   })
    // }
    updateLocalChatMemoFromCloud(data)
    globalOnDemandVars.set_chatMemoReady(true)
  } else {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'appsync / create 안된 원래있던 ChatMemo ',
        value: { ChatMemo }
      // , important: true
      })
    }
    ChatMemoFromCloud = ChatMemo
    updateLocalChatMemoFromCloud(ChatMemoFromCloud)
    // defer(() => {
    globalOnDemandVars.set_chatMemoReady(true)
    // })
  }
}

function updateLocalChatMemoFromCloud (ChatMemoFromCloud) {
  globalOnDemandVars.set_chatMemoValue(ChatMemoFromCloud.value)
}
